import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createSyncBlockNode } from '../utils/createSyncBlock';
import { resolveSyncBlockInstance } from '../utils/resolveSyncBlockInstance';
export var ReferenceSyncBlockStoreManager = /*#__PURE__*/function () {
  function ReferenceSyncBlockStoreManager(dataProvider) {
    _classCallCheck(this, ReferenceSyncBlockStoreManager);
    _defineProperty(this, "isRefreshingSubscriptions", false);
    this.syncBlockCache = new Map();
    this.subscriptions = new Map();
    this.dataProvider = dataProvider;
    this.syncBlockURLRequests = new Map();
  }

  /**
   * Refreshes the subscriptions for all sync blocks.
   * @returns {Promise<void>}
   */
  return _createClass(ReferenceSyncBlockStoreManager, [{
    key: "refreshSubscriptions",
    value: (function () {
      var _refreshSubscriptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var syncBlocks, _iterator, _step, _loop;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.isRefreshingSubscriptions) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              this.isRefreshingSubscriptions = true;
              syncBlocks = [];
              _iterator = _createForOfIteratorHelper(this.subscriptions.entries());
              _context2.prev = 5;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var _step$value, resourceId, callbacks;
                return _regeneratorRuntime.wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _step$value = _slicedToArray(_step.value, 2), resourceId = _step$value[0], callbacks = _step$value[1];
                      Object.keys(callbacks).forEach(function (localId) {
                        syncBlocks.push(createSyncBlockNode(localId, resourceId));
                      });
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 8:
              if ((_step = _iterator.n()).done) {
                _context2.next = 12;
                break;
              }
              return _context2.delegateYield(_loop(), "t0", 10);
            case 10:
              _context2.next = 8;
              break;
            case 12:
              _context2.next = 17;
              break;
            case 14:
              _context2.prev = 14;
              _context2.t1 = _context2["catch"](5);
              _iterator.e(_context2.t1);
            case 17:
              _context2.prev = 17;
              _iterator.f();
              return _context2.finish(17);
            case 20:
              _context2.prev = 20;
              _context2.next = 23;
              return this.fetchSyncBlocksData(syncBlocks);
            case 23:
              _context2.next = 27;
              break;
            case 25:
              _context2.prev = 25;
              _context2.t2 = _context2["catch"](20);
            case 27:
              _context2.prev = 27;
              this.isRefreshingSubscriptions = false;
              return _context2.finish(27);
            case 30:
            case "end":
              return _context2.stop();
          }
        }, _callee, this, [[5, 14, 17, 20], [20, 25, 27, 30]]);
      }));
      function refreshSubscriptions() {
        return _refreshSubscriptions.apply(this, arguments);
      }
      return refreshSubscriptions;
    }())
  }, {
    key: "fetchSyncBlockSourceURL",
    value: function fetchSyncBlockSourceURL(resourceId) {
      var _this = this;
      if (!resourceId || !this.dataProvider) {
        return;
      }

      // if the sync block is a reference block, we need to fetch the URL to the source
      // we could optimise this further by checking if the sync block is on the same page as the source
      if (!this.syncBlockURLRequests.get(resourceId)) {
        this.syncBlockURLRequests.set(resourceId, true);
        this.dataProvider.retrieveSyncBlockSourceUrl(createSyncBlockNode('', resourceId)).then(function (sourceURL) {
          var existingSyncBlock = _this.getFromCache(resourceId);
          if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data = _objectSpread(_objectSpread({}, existingSyncBlock.data), {}, {
              sourceURL: sourceURL
            });
            _this.updateCache(existingSyncBlock);
          }
        }).finally(function () {
          _this.syncBlockURLRequests.set(resourceId, false);
        });
      }
    }
  }, {
    key: "fetchSyncBlocksData",
    value: function () {
      var _fetchSyncBlocksData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(syncBlockNodes) {
        var _this2 = this;
        var data, resolvedData;
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.dataProvider) {
                _context3.next = 2;
                break;
              }
              throw new Error('Data provider not set');
            case 2:
              _context3.next = 4;
              return this.dataProvider.fetchNodesData(syncBlockNodes);
            case 4:
              data = _context3.sent;
              if (data) {
                _context3.next = 7;
                break;
              }
              throw new Error('Failed to fetch sync block node data');
            case 7:
              resolvedData = [];
              data.forEach(function (syncBlockInstance) {
                var _resolvedSyncBlockIns;
                if (!syncBlockInstance.resourceId) {
                  return;
                }
                var existingSyncBlock = _this2.getFromCache(syncBlockInstance.resourceId);
                var resolvedSyncBlockInstance = existingSyncBlock ? resolveSyncBlockInstance(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
                _this2.updateCache(resolvedSyncBlockInstance);
                resolvedData.push(resolvedSyncBlockInstance);

                // fetch source URL if not already present
                if (!((_resolvedSyncBlockIns = resolvedSyncBlockInstance.data) !== null && _resolvedSyncBlockIns !== void 0 && _resolvedSyncBlockIns.sourceURL) && resolvedSyncBlockInstance.resourceId) {
                  _this2.fetchSyncBlockSourceURL(resolvedSyncBlockInstance.resourceId);
                }
              });
              return _context3.abrupt("return", resolvedData);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function fetchSyncBlocksData(_x) {
        return _fetchSyncBlocksData.apply(this, arguments);
      }
      return fetchSyncBlocksData;
    }()
  }, {
    key: "updateCache",
    value: function updateCache(syncBlock) {
      var resourceId = syncBlock.resourceId;
      if (resourceId) {
        this.syncBlockCache.set(resourceId, syncBlock);
        var callbacks = this.subscriptions.get(resourceId);
        if (callbacks) {
          Object.values(callbacks).forEach(function (callback) {
            callback(syncBlock);
          });
        }
      }
    }
  }, {
    key: "getFromCache",
    value: function getFromCache(resourceId) {
      return this.syncBlockCache.get(resourceId);
    }
  }, {
    key: "deleteFromCache",
    value: function deleteFromCache(resourceId) {
      this.syncBlockCache.delete(resourceId);
    }
  }, {
    key: "subscribe",
    value: function subscribe(node, callback) {
      var _this3 = this;
      // check node is a sync block, as we only support sync block subscriptions
      if (node.type.name !== 'syncBlock') {
        return function () {};
      }
      var _node$attrs = node.attrs,
        resourceId = _node$attrs.resourceId,
        localId = _node$attrs.localId;
      if (!localId || !resourceId) {
        return function () {};
      }

      // add to subscriptions map
      var resourceSubscriptions = this.subscriptions.get(resourceId) || {};
      this.subscriptions.set(resourceId, _objectSpread(_objectSpread({}, resourceSubscriptions), {}, _defineProperty({}, localId, callback)));

      // call the callback immediately if we have cached data
      var cachedData = this.getFromCache(resourceId);
      if (cachedData) {
        callback(cachedData);
      } else {
        this.fetchSyncBlocksData([createSyncBlockNode(localId, resourceId)]).catch(function () {});
      }
      return function () {
        var resourceSubscriptions = _this3.subscriptions.get(resourceId);
        if (resourceSubscriptions) {
          delete resourceSubscriptions[localId];
          if (Object.keys(resourceSubscriptions).length === 0) {
            _this3.subscriptions.delete(resourceId);
            _this3.deleteFromCache(resourceId);
          } else {
            _this3.subscriptions.set(resourceId, resourceSubscriptions);
          }
        }
      };
    }

    /**
     * Get the URL for a sync block.
     * @param resourceId - The resource ID of the sync block
     * @returns
     */
  }, {
    key: "getSyncBlockURL",
    value: function getSyncBlockURL(resourceId) {
      var _syncBlock$data;
      var syncBlock = this.getFromCache(resourceId);
      if (!syncBlock) {
        return undefined;
      }
      return (_syncBlock$data = syncBlock.data) === null || _syncBlock$data === void 0 ? void 0 : _syncBlock$data.sourceURL;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.syncBlockCache.clear();
      this.subscriptions.clear();
      this.syncBlockURLRequests.clear();
    }
  }]);
}();